import { faEdit } from "@fortawesome/pro-solid-svg-icons";
import React from "react";

import { ProfileFacebookVendorPage } from "@/mk2/apps/blogs/components/ProfileFacebookVendorPage";
import { ProfileDetailData } from "@/mk2/apps/blogs/containers/ProfileDetail/ProfileDetail.reducers";
import { blogsProfileEditProUrl } from "@/mk2/apps/blogs/urls";
import { Btn, BtnType } from "@/mk2/components/Btn";
import { ImgVarHeight } from "@/mk2/components/ImgVarHeight";
import { Link } from "@/mk2/components/Link";
import { url } from "@/mk2/helpers/urls";
import { UserEntity } from "@/mk2/schemas";
import {
    ADDRESS,
    CARD_TEXT,
    EDIT_PROFILE_SETTINGS,
    EMAIL,
    HEADING_MY_SHOP,
    PHONE,
    VENDOR_NAME,
    WEB,
} from "@/mk/autogenerated/translations/AboutProMe.bc83930b8ef2dc2e4dbea9fd8883cffc";
import { isUrlWithProtocol } from "@/mk/bazaar/common/filters/urlize";
import { canManageBlogs, isAuthenticatedAs } from "@/mk/bazaar/common/userUtils";

import styles from "./AboutProMe.mscss";

interface OwnProps {
    isMobile: boolean;
    profileDetailData: ProfileDetailData;
    requestUser: UserEntity;
    requestUserPermissions: string[];
}

type Props = OwnProps;

export default class AboutProMe extends React.Component<Props> {
    public render() {
        const { isMobile, profileDetailData, requestUser, requestUserPermissions } = this.props;
        const { user, userVendorData } = profileDetailData;

        const isAdmin = canManageBlogs(requestUserPermissions);
        const isOwner = isAuthenticatedAs(requestUser, user);

        const logoWidth =
            isMobile && userVendorData.logoPhoto
                ? Math.min(350, userVendorData.logoPhoto.width)
                : 296;
        const fbWidth = isMobile ? logoWidth : 296;

        return (
            <>
                <div className={styles.AboutProMe}>
                    {userVendorData.logoPhoto && (
                        <div className={styles.AboutProMe__logo}>
                            <ImgVarHeight
                                alt="Vendor logo"
                                photo={userVendorData.logoPhoto}
                                width={logoWidth}
                                photoVersion={"s200x200"}
                                className={styles.AboutProMe__logo__image}
                            />
                        </div>
                    )}
                    <h2 className={styles.AboutProMe__heading}>{HEADING_MY_SHOP}</h2>
                    <ul className={styles.AboutProMe__info}>
                        {userVendorData.name && (
                            <li>
                                <span className={styles.AboutProMe__info__label}>
                                    {VENDOR_NAME}:
                                </span>
                                &nbsp;
                                <span className={styles.AboutProMe__info__value}>
                                    {userVendorData.name}
                                </span>
                            </li>
                        )}
                        {userVendorData.address && (
                            <li>
                                <span className={styles.AboutProMe__info__label}>{ADDRESS}:</span>
                                &nbsp;
                                <span className={styles.AboutProMe__info__value}>
                                    {userVendorData.address}
                                </span>
                            </li>
                        )}
                        {userVendorData.phone && (
                            <li>
                                <span className={styles.AboutProMe__info__label}>{PHONE}:</span>
                                &nbsp;
                                <span className={styles.AboutProMe__info__value}>
                                    {userVendorData.phone}
                                </span>
                            </li>
                        )}
                        {userVendorData.email && (
                            <li>
                                <span className={styles.AboutProMe__info__label}>{EMAIL}:</span>
                                &nbsp;
                                <span className={styles.AboutProMe__info__value}>
                                    <Link to={`mailto:${userVendorData.email}`}>
                                        {userVendorData.email}
                                    </Link>
                                </span>
                            </li>
                        )}
                        {userVendorData.web && (
                            <li>
                                <span className={styles.AboutProMe__info__label}>{WEB}:</span>
                                &nbsp;
                                <span className={styles.AboutProMe__info__value}>
                                    <a
                                        data-google-interstitial="false"
                                        href={
                                            isUrlWithProtocol(userVendorData.web)
                                                ? userVendorData.web
                                                : `//${userVendorData.web}`
                                        }
                                        target="_blank"
                                        rel="noopener"
                                    >
                                        {userVendorData.web}
                                    </a>
                                </span>
                            </li>
                        )}
                        {userVendorData.card_text && (
                            <li>
                                <span className={styles.AboutProMe__info__label}>{CARD_TEXT}:</span>
                                &nbsp;
                                <span className={styles.AboutProMe__info__value}>
                                    {userVendorData.card_text}
                                </span>
                            </li>
                        )}
                    </ul>
                    {/* CeMi: 2020-10-07 disabled pocas review FB appky
                     userVendorData.facebook && (
                        <div className={styles.AboutProMe__facebookBanner}>
                            <ProfileFacebookVendorPage
                                fbPageUrl={userVendorData.facebook}
                                width={fbWidth}
                            />
                        </div>
                    )*/}

                    {(isOwner || isAdmin) && (
                        <div className={styles.AboutProMe__edit}>
                            <Btn
                                icon={faEdit}
                                label={EDIT_PROFILE_SETTINGS}
                                link={url(blogsProfileEditProUrl, { username: user.username })}
                                sidePadding={0}
                                type={isAdmin ? BtnType.AdminTextLight : BtnType.Link}
                            />
                        </div>
                    )}
                </div>
            </>
        );
    }
}
